(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-lot', {
            parent: 'entity',
            url: '/product-lot?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productLot.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-lot/product-lots.html',
                    controller: 'ProductLotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productLot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-lot-detail', {
            parent: 'entity',
            url: '/product-lot/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productLot.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-lot/product-lot-detail.html',
                    controller: 'ProductLotDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productLot');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductLot', function($stateParams, ProductLot) {
                    return ProductLot.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-lot.new', {
            parent: 'product-lot',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-lot/product-lot-dialog.html',
                    controller: 'ProductLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                referenceNumber: null,
                                expirationMonth: null,
                                fromIdNumber: null,
                                toIdNumber: null,
                                registrationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-lot', null, { reload: true });
                }, function() {
                    $state.go('product-lot');
                });
            }]
        })
        .state('product-lot.edit', {
            parent: 'product-lot',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-lot/product-lot-dialog.html',
                    controller: 'ProductLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductLot', function(ProductLot) {
                            return ProductLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-lot.delete', {
            parent: 'product-lot',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-lot/product-lot-delete-dialog.html',
                    controller: 'ProductLotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductLot', function(ProductLot) {
                            return ProductLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
